import {
  Box,
  Button,
  Card,
  CardBody,
  Flex,
  HStack,
  Stack,
  Text,
  Wrap,
} from "@chakra-ui/react";
import { Clock, Download } from "react-feather";

import { useEffect, useRef, useState } from "react";
import { fetchDownloadLink } from "../../api/lucroVault";

const ResourceCard = ({
  description,
  type,
  tags,
  title,
  resourceLink,
  resourceVideoLink,
  videoDuration,
  backgroundImage = null,
  setSelectedResource,
  resourceData,
  toggleView,
}) => {
  const [fontSize, setFontSize] = useState(17);
  const textRef = useRef(null);

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      if (textRef.current) {
        const lines = textRef.current.clientHeight / parseInt(fontSize);
        if (lines > 3) {
          setFontSize((prev) => Math.max(prev - 1, 13));
        }
      }
    });

    if (textRef.current) {
      observer.observe(textRef.current);
    }

    return () => observer.disconnect();
  }, [description, fontSize]);

  return (
    <Stack width="100%" p="0px" fontFamily="lato">
      <Card width="100%" borderRadius="20px" minH="461px" height="100%">
        <CardBody p="16px" height="100%" display="flex" flexDirection="column">
          <Box
            width="100%"
            aspectRatio={16 / 9}
            borderRadius="10px"
            position="relative"
            backgroundImage={backgroundImage || "url('/resource-frame.png')"}
            backgroundSize="102% 102%"
            backgroundRepeat="no-repeat"
            backgroundPosition="center 25%"
            p={0}
          />

          <Flex
            direction="column"
            flex="1"
            minHeight="0"
            overflow="hidden"
            mt={"24px"}
          >
            <HStack spacing={2} flexWrap="wrap">
              {tags?.map((tag) => (
                <Box
                  key={tag.id}
                  backgroundColor={tag.label_color}
                  fontFamily="Lato"
                  borderRadius="40px"
                  display="inline-flex"
                  alignItems="center"
                  height="28px"
                  px="10px"
                  fontWeight={"700"}
                >
                  <Text fontSize="15px">{tag.name}</Text>
                </Box>
              ))}
            </HStack>

            <Text
              mt={"12px"}
              fontSize="18px"
              fontFamily="Poppins"
              fontWeight={700}
              lineHeight="1.2"
              color="#1A202C"
              textAlign="left"
              noOfLines={2}
              sx={{
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 2,
                overflow: "hidden",
                wordBreak: "break-word",
                whiteSpace: "normal",
              }}
            >
              {title}
            </Text>

            <Box mt={"auto"} mb={"auto"}>
              <Text
                fontSize="14px"
                fontWeight={500}
                fontFamily="Poppins"
                lineHeight="1.2"
                color="#4A5568"
                textAlign="left"
                noOfLines={3}
                mt={"15px"}
                mb={"15px"}
                sx={{
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 3,
                  overflow: "hidden",
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                }}
              >
                {description}
              </Text>
            </Box>

            <Wrap spacing={2} mt="auto">
              {(resourceVideoLink || resourceData?.is_workshop) && (
                <Button
                  backgroundColor="#536DEC"
                  borderRadius="4px"
                  display="inline-flex"
                  alignItems="center"
                  height="36px"
                  px="10px"
                  onClick={() => {
                    setSelectedResource(resourceData);
                    toggleView(true);
                  }}
                >
                  <HStack spacing="6px" align="center">
                    <Text
                      fontSize="15px"
                      fontWeight={500}
                      color="white"
                      fontFamily="Poppins"
                    >
                      {resourceData?.is_workshop ? "View now →" : "Watch now →"}
                    </Text>
                  </HStack>
                </Button>
              )}
              {(resourceData?.resource_file || resourceData?.resource_link) && !resourceData?.is_workshop && (
                <Button
                  backgroundColor="#536DEC"
                  borderRadius="4px"
                  display="inline-flex"
                  alignItems="center"
                  height="36px"
                  px="10px"
                  onClick={async () => {
                    try {
                      if (resourceData?.resource_type === "external") {
                        window.open(resourceData.resource_link, "_blank");
                      } else {
                        const response = await fetchDownloadLink(
                          resourceData?.id
                        );
                        const fileUrl = response?.url;

                        if (fileUrl) {
                          const a = document.createElement("a");
                          a.href = fileUrl;
                          if (response.filename) {
                            a.download = response.filename;
                          }
                          document.body.appendChild(a);
                          a.click();
                          a.remove();
                        } else {
                          console.error("No URL returned in response");
                        }
                      }
                    } catch (error) {
                      console.error("Error fetching download URL", error);
                    }
                  }}
                >
                  <HStack spacing="6px" align="center">
                    <Text
                      fontSize="15px"
                      fontWeight={500}
                      color="white"
                      fontFamily="Poppins"
                    >
                      Download
                    </Text>
                    <Download size="15px" color="white" />
                  </HStack>
                </Button>
              )}

              {videoDuration &&
                (resourceVideoLink || resourceData?.is_workshop) && (
                  <HStack spacing={1}>
                    <Box fontSize="15px" color="black">
                      <Clock size={15} />
                    </Box>
                    <Box
                      fontSize="13px"
                      color="#4A5568"
                      fontWeight={700}
                      fontFamily="Lato"
                    >
                      {resourceData?.is_workshop
                        ? `${videoDuration} min content`
                        : `${videoDuration} min watch`}
                    </Box>
                  </HStack>
                )}
            </Wrap>
          </Flex>
        </CardBody>
      </Card>
    </Stack>
  );
};

export default ResourceCard;
